
export const isChild = (parent, child) => {
    const refId = parent.refPid;
    if (child.showCondition) {
        for(let c of child.showCondition) {
            if (c.parentRefPid === refId) {
                return true;
            }
        }
    }
    return false;
}

const computedValues = (values, vid) => {
    return values ? values.filter(v => {
        return v.parentVids.indexOf(vid) !== -1;
    }) : []
}
export const getConditionItems = (conditionItems, item, val) => {
    const refPid = item.refPid;
    const vid = val.vid;
    return conditionItems.filter(conItem => {  
        const condition = (conItem.showCondition || []).find(con => con.parentRefPid === refPid)
        if (condition && condition.parentVids.includes(vid)) {
            const values = computedValues(conItem.values, vid);
            if (values.length) {
                conItem.options = values;
            }
            return true
        }
        // const index = (conItem.showCondition || []).find(con => con.parentRefPid === refPid)
        // if (idx !== -1 && vid) {
        //     const values = computedValues(conItem.values, vid);
        //     if (values.length) {
        //         conItem.options = values;
        //     }
        //     return values.length;
        // }
        return false;
    }).map(newItem => {
        return {
            ...newItem,
            options: newItem.options
        }
    });
}
export const getAttrByParentId = (attrs, refId) => {
    let len = attrs.length;
    const idx = [];
    for(let i = 0; i < len; i++) {
        const attr = attrs[i];
        const fIdx = (attr.showCondition || []).findIndex(con => con.parentRefPid === refId)
        if (fIdx !== -1) {
            idx.push(i);
        }
    }
    return idx;
}

export const getLenWith = (text) => {
    const arr = text.split('');
    let reg = /[\u4e00-\u9fa5]/;
    return arr.reduce((acc, ch) => {
        if (reg.test(ch)) {
            return acc + 2;
        }
        return acc + 1;
    }, 0)
}
export function transToBase64(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            resolve(e.target.result);
        }
        reader.onerror = (e) => {
            console.error(e);
            resolve('')
        }
    })
}